import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "m-0 px-7 shrink-0 flex items-center justify-between"
};
const _hoisted_2 = {
  class: "flex items-center gap-2"
};
const _hoisted_3 = ["innerHTML"];
import { Markmap } from 'markmap-view';
import { Transformer } from 'markmap-lib';
import { Toolbar } from 'markmap-toolbar';
import markdownit from 'markdown-it';
import download from '@/utils/download';
import { nextTick, onMounted, ref, watch } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import Icon from '@/components/Icon/src/Icon.vue';
import { ElLoading } from 'element-plus';
export default /*@__PURE__*/_defineComponent({
  __name: 'Write',
  props: {
    generatedContent: {},
    isEnd: {
      type: Boolean
    },
    isGenerating: {
      type: Boolean
    },
    isStart: {
      type: Boolean
    }
  },
  emits: ['handle-close'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const md = markdownit();
    const message = useMessage(); // 消息弹窗
    const emits = __emit;
    const props = __props;
    const contentRef = ref(); // 右侧出来 header 以下的区域
    const mdContainerRef = ref(); // markdown 的容器，用来滚动到底下的
    const mindMapRef = ref(); // 思维导图的容器
    const svgRef = ref(); // 思维导图的渲染 svg
    const toolBarRef = ref(); // 思维导图右下角的工具栏，缩放等
    const html = ref(''); // 生成过程中的文本
    const contentAreaHeight = ref(0); // 生成区域的高度，出去 header 部分
    let markMap = null;
    const transformer = new Transformer();
    const back = () => {
      emits('handle-close');
    };
    onMounted(() => {
      contentAreaHeight.value = contentRef.value?.clientHeight || 0; // 获取区域高度
      /** 初始化思维导图 **/
      try {
        markMap = Markmap.create(svgRef.value);
        const {
          el
        } = Toolbar.create(markMap);
        toolBarRef.value?.append(el);
        nextTick(update);
      } catch (e) {
        message.error('思维导图初始化失败');
      }
    });
    watch(props, ({
      generatedContent,
      isGenerating,
      isEnd,
      isStart
    }) => {
      // 开始生成的时候清空一下 markdown 的内容
      if (isStart) {
        html.value = '';
      }
      // 生成内容的时候使用 markdown 来渲染
      if (isGenerating) {
        html.value = md.render(generatedContent);
      }
      // 生成结束时更新思维导图
      if (isEnd) {
        update();
      }
    });
    /** 更新思维导图的展示 */
    const update = () => {
      try {
        const {
          root
        } = transformer.transform(processContent(props.generatedContent));
        markMap?.setData(root);
        markMap?.fit();
      } catch (e) {
        console.error(e);
      }
    };
    /** 处理内容 */
    const processContent = text => {
      const arr = [];
      const lines = text.split('\n');
      for (let line of lines) {
        if (line.indexOf('```') !== -1) {
          continue;
        }
        line = line.replace(/([*_~`>])|(\d+\.)\s/g, '');
        arr.push(line);
      }
      return arr.join('\n');
    };
    /** 下载图片：download SVG to png file */
    const downloadImage = () => {
      if (!svgRef.value) {
        message.error('无法获取思维导图内容');
        return;
      }
      // 显示加载提示
      const loadingInstance = ElLoading.service({
        lock: true,
        text: '正在生成图片，请稍候...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        // 获取 SVG 元素的实际尺寸
        const svgElement = svgRef.value;
        const rect = svgElement.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(svgElement);
        // 获取实际渲染尺寸
        const svgSvgElement = svgElement;
        const width = svgSvgElement.viewBox?.baseVal?.width || rect.width || parseInt(computedStyle.width) || 800;
        const height = svgSvgElement.viewBox?.baseVal?.height || rect.height || parseInt(computedStyle.height) || 600;
        // 获取所有样式表
        const styleSheets = Array.from(document.styleSheets);
        let cssText = '';
        try {
          styleSheets.forEach(sheet => {
            try {
              const rules = Array.from(sheet.cssRules || sheet.rules || []);
              rules.forEach(rule => {
                // 只包含与 markmap 相关的样式
                if (rule.cssText && (rule.cssText.includes('markmap') || rule.cssText.includes('mm-'))) {
                  cssText += rule.cssText + '\n';
                }
              });
            } catch (e) {
              // 忽略跨域样式表错误
            }
          });
        } catch (e) {
          console.warn('无法获取样式表:', e);
        }
        // 序列化 SVG
        const serializer = new XMLSerializer();
        let source = serializer.serializeToString(svgElement);
        // 添加必要的命名空间和属性
        if (!source.includes('xmlns=')) {
          source = source.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
        }
        if (!source.includes('xmlns:xlink')) {
          source = source.replace('<svg', '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
        }
        // 设置明确的宽高
        if (!source.includes('width=')) {
          source = source.replace('<svg', `<svg width="${width}" height="${height}"`);
        }
        // 如果有样式，添加到 SVG 中
        if (cssText) {
          const styleTag = `<style><![CDATA[${cssText}]]></style>`;
          source = source.replace('>', `>${styleTag}`);
        }
        // 添加 XML 声明
        source = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n${source}`;
        console.log('SVG 数据准备完成，开始下载...', {
          width,
          height,
          hasStyles: !!cssText
        });
        // 关闭加载提示
        loadingInstance.close();
        // 显示处理提示
        message.info('正在处理下载，请稍候...');
        // 使用优化后的 SVG 转 PNG 方法
        download.svgToPng({
          svgData: source,
          fileName: 'mindmap.png',
          width: Math.round(width),
          height: Math.round(height)
        });
        // 延迟显示成功消息（给下载一些时间）
        setTimeout(() => {
          message.success('下载已开始，如果未自动下载请检查浏览器设置');
        }, 1000);
      } catch (error) {
        // 关闭加载提示
        loadingInstance.close();
        console.error('下载图片失败:', error);
        message.error('下载失败，请稍后重试');
      }
    };
    __expose({
      scrollBottom() {
        mdContainerRef.value?.scrollTo(0, mdContainerRef.value?.scrollHeight);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createBlock(_component_el_card, {
        class: "my-card h-full flex-grow"
      }, {
        header: _withCtx(() => [_createElementVNode("h3", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: back,
          size: "small"
        }, {
          icon: _withCtx(() => [_createVNode(Icon, {
            icon: "mynaui:fat-arrow-left"
          })]),
          _: 1
        }), _cache[0] || (_cache[0] = _createElementVNode("span", null, "预览", -1))]), _withDirectives(_createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: downloadImage
        }, {
          icon: _withCtx(() => [_createVNode(Icon, {
            icon: "ph:copy-bold"
          })]),
          default: _withCtx(() => [_cache[1] || (_cache[1] = _createTextVNode(" 下载图片 "))]),
          _: 1
        }, 512), [[_vShow, _ctx.isEnd]])])]),
        default: _withCtx(() => [_createElementVNode("div", {
          ref_key: "contentRef",
          ref: contentRef,
          class: "hide-scroll-bar h-full box-border"
        }, [_ctx.isGenerating ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "mdContainerRef",
          ref: mdContainerRef,
          class: "wh-full overflow-y-auto"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center justify-center",
          innerHTML: html.value
        }, null, 8, _hoisted_3)], 512)) : _createCommentVNode("", true), _createElementVNode("div", {
          ref_key: "mindMapRef",
          ref: mindMapRef,
          class: "wh-full"
        }, [(_openBlock(), _createElementBlock("svg", {
          ref_key: "svgRef",
          ref: svgRef,
          style: _normalizeStyle({
            height: `${contentAreaHeight.value}px`
          }),
          class: "w-full"
        }, null, 4)), _createElementVNode("div", {
          ref_key: "toolBarRef",
          ref: toolBarRef,
          class: "absolute bottom-[10px] right-5"
        }, null, 512)], 512)], 512)]),
        _: 1
      });
    };
  }
});